module.exports = __webpack_public_path__ + "img/no-order.e23a5cf7.png";